import { Container, Row, Col, Button } from 'react-bootstrap';
import styled from "styled-components"

import '../GlobalStyle.css';

import ClientSmartColumbus from '../../assets/images/Client Logo - Smart Columbus.jpg'
import ClientCityColumbus from '../../assets/images/Client Logo - City of Columbus.png';
import ClientDahon from '../../assets/images/Client Logo - Dahon.jpg';
import ClientSunPower from '../../assets/images/Client Logo - SunPower.png';
import ClientPowur from '../../assets/images/Client Logo - Powur.png';
import ClientRollingStrong from '../../assets/images/Client Logo - Rolling Strong.png';
import ClientKia from '../../assets/images/Client Logo - Kia.png';
import ClientWebasto from '../../assets/images/Client Logo - Webasto.png';

const Scroller = styled.div`
    overflow: hidden;
    display: flex;
    padding: 60px 0;
    white-space: nowrap;
    position: relative;

    img {
        margin: auto 1.5rem;
        flex: none;
        height: 50px;
        filter: saturate(0%);

    }
    

    span {
        animation: logo 60s linear infinite;
        display: inline-block;

        @keyframes logo {
            0% {
                transform: translateX(0);
            }
            100% {
                transform: translateX(-100%);
            }
        }
    }
    
`



const LogoScroll = () => {
    return (
        <>

            <Container fluid className='text-center'>
                <Row>
                    <Col>
                        <Scroller>
                            <span>
                                <img src={ClientCityColumbus} alt='client logos' />
                                <img src={ClientSmartColumbus} alt='client logos' />
                                <img src={ClientDahon} alt='client logos' />
                                <img src={ClientWebasto} alt='client logos' />
                                <img src={ClientKia} alt='client logos' />
                                <img src={ClientSunPower} alt='client logos' />
                                <img src={ClientPowur} alt='client logos' />
                                <img src={ClientRollingStrong} alt='client logos' />
                            </span>
                            <span>
                                <img src={ClientCityColumbus} alt='client logos' />
                                <img src={ClientSmartColumbus} alt='client logos' />
                                <img src={ClientDahon} alt='client logos' />
                                <img src={ClientWebasto} alt='client logos' />
                                <img src={ClientKia} alt='client logos' />
                                <img src={ClientSunPower} alt='client logos' />
                                <img src={ClientPowur} alt='client logos' />
                                <img src={ClientRollingStrong} alt='client logos' />
                            </span>
                        </Scroller>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default LogoScroll;